import { ActivatedRoute } from '@angular/router';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { AppSettings } from '../../utils/app-settings';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
var InfluencerConnectionComponent = /** @class */ (function () {
    function InfluencerConnectionComponent(route, influencerService, placeholder) {
        this.route = route;
        this.influencerService = influencerService;
        this.placeholder = placeholder;
        this.isAccepted = false;
        this.isProcessing = false;
        this.isRejected = false;
    }
    InfluencerConnectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            if (params.token) {
                _this.permissionToken = params.token;
                _this.acceptPermission();
            }
        });
    };
    InfluencerConnectionComponent.prototype.acceptPermission = function () {
        var _this = this;
        this.influencerService.acceptContactPermission(this.permissionToken).subscribe(function (res) {
            _this.influencerName = res.influencer_name;
            _this.advertiserName = res.advertiser_name;
            _this.companyName = res.agency_name;
            _this.afterAcceptedPermission();
        });
    };
    InfluencerConnectionComponent.prototype.afterAcceptedPermission = function () {
        this.isAccepted = true;
        this.isRejected = false;
    };
    InfluencerConnectionComponent.prototype.rejectPermission = function () {
        var _this = this;
        if (this.permissionToken) {
            this.influencerService.rejectContactPermission(this.permissionToken).subscribe(function (res) {
                _this.afterRejectedPermission();
            });
        }
    };
    InfluencerConnectionComponent.prototype.afterRejectedPermission = function () {
        this.isAccepted = false;
        this.isRejected = true;
    };
    Object.defineProperty(InfluencerConnectionComponent.prototype, "marketingLink", {
        get: function () {
            return AppSettings.influencerProgramMarketingLink();
        },
        enumerable: true,
        configurable: true
    });
    InfluencerConnectionComponent.prototype.openIntercom = function () {
        if (typeof window.Intercom === 'function') {
            window.Intercom('showMessages');
        }
    };
    return InfluencerConnectionComponent;
}());
export { InfluencerConnectionComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-connection/influencer-connection.component.ts.pre-build-optimizer.js